import { render, staticRenderFns } from "./PosPrescriptionModal.template.vue?vue&type=template&id=402525ac&scoped=true&"
var script = {}
import style0 from "./PosPrescriptionModal.template.vue?vue&type=style&index=0&id=402525ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402525ac",
  null
  
)

export default component.exports